import { motion } from "framer-motion"
import { Zap, X } from "lucide-react"
import { useTenant } from "@/hooks/useTenant"

export function GodModeBanner() {
  const { isGodMode, godModeTenant, exitGodMode } = useTenant()

  if (!isGodMode || !godModeTenant) return null

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 z-[100] flex items-center justify-center gap-3 px-4 py-2"
      style={{
        background:
          "linear-gradient(90deg, rgba(217,119,6,0.92) 0%, rgba(245,158,11,0.92) 100%)",
        backdropFilter: "blur(20px)",
        borderBottom: "1px solid rgba(251,191,36,0.6)",
      }}
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -40, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Zap className="w-4 h-4 text-white shrink-0" aria-hidden />
      <p className="text-sm font-semibold text-white">
        Modo Suporte — ESC:{" "}
        <span className="font-bold">{godModeTenant.name}</span>
      </p>
      <button
        onClick={exitGodMode}
        className="ml-4 flex items-center gap-1.5 rounded-lg bg-white/20 px-3 py-1 text-xs font-semibold text-white transition hover:bg-white/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
        aria-label="Sair do Modo Suporte"
      >
        <X className="w-3 h-3" />
        Sair
      </button>
    </motion.div>
  )
}
